module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Example', {
    attrs: {
      "component": _vm.ExSimple,
      "code": _vm.ExSimpleCode
    }
  }, [_c('p', [_vm._v("The Loading will be closed after about 10 seconds, by pressing escape or by clicking outside.")]), _vm._v(" "), _c('p', [_vm._v("\n                Use "), _c('code', [_vm._v(":is-full-page=\"false\"")]), _vm._v(" to limit loader to its container."), _c('br'), _vm._v("\n                In this case, the container element should be positioned as "), _c('code', [_vm._v("position: relative")]), _vm._v(".\n            ")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExProgrammatically,
      "code": _vm.ExProgrammaticallyCode,
      "title": "Programmatically opening"
    }
  }, [_c('p', [_vm._v("When you want to close the Loading, call the "), _c('code', [_vm._v("close()")]), _vm._v(" method from the component.")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExTemplated,
      "code": _vm.ExTemplatedCode,
      "title": "Templated"
    }
  }, [_c('div', {
    staticClass: "tags has-addons"
  }, [_c('span', {
    staticClass: "tag is-success"
  }, [_vm._v("New!")]), _vm._v(" "), _c('span', {
    staticClass: "tag is-info"
  }, [_vm._v("0.7.5")])]), _vm._v(" "), _c('p', [_vm._v("Slot is available for loading content.")])]), _vm._v(" "), _c('ApiView', {
    attrs: {
      "data": _vm.api
    }
  }), _vm._v(" "), _c('VariablesView', {
    attrs: {
      "data": _vm.variables
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f9c49b32"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/loading/Loading.vue
// module id = 1423
// module chunks = 31